import { Box, MenuItem, Select, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Styles from '../Config/Styles';

const SelectBox = ({ data, selectedValues1, setSelectedValues1 }) => {
    useEffect(() => {
        if (!selectedValues1?.length) {
            const defaultValues = data?.map((item) => ({
                attribute_name: item?.attri_name.name, // Attribute name
                attribute_value: item?.fields[0]?.Values_id?.name || "", // Default to the first option
            })) || [];
            setSelectedValues1(defaultValues);
        }
    }, [data]);

    const handleChange = (e, item) => {
        const selectedValue = e.target.value;

        setSelectedValues1((prevState) => {
            const updatedValues = [...prevState];
            const index = updatedValues.findIndex((entry) => entry.attribute_name === item.attri_name.name);

            if (index !== -1) {
                updatedValues[index] = { attribute_name: item.attri_name.name, attribute_value: selectedValue, id: updatedValues[index].id };
            } else {
                updatedValues.push({ attribute_name: item.attri_name.name, attribute_value: selectedValue });
            }

            return updatedValues;
        });
    };

    const getSelectedValue = (item) => {
        const match = selectedValues1?.find((i) => i.attribute_name === item.attri_name.name);
        return match?.attribute_value || item?.fields[0]?.Values_id?.name || ""; // Default to the first option
    };

    const handleDisabled = (item) => {
        return item?.fields?.length < 2;
    };

    return (
        <>
            {data?.map((item) => (
                <Box sx={{ mt: 2 }} key={item?.attri_name?.id}>
                    <Typography sx={{ textAlign: "start", fontWeight: 600, textTransform: 'none' }}>
                        {item?.attri_name.name}
                        <span style={{ color: '#FF0202' }}>*</span>
                    </Typography>
                    <Select
                        name={item?.attri_name.name}
                        disabled={handleDisabled(item)}
                        value={getSelectedValue(item)} // Dynamically set the selected value
                        onChange={(e) => handleChange(e, item)}
                        sx={Styles.select.input}
                    >
                        {item?.fields?.map((i) => (
                            <MenuItem key={i?.Values_id?.name} value={i.Values_id?.name}>
                                {i?.Values_id?.name}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
            ))}
        </>
    );
};

export default SelectBox;
